export default (value, accessor, tuple) => {
    if(!!tuple[`__ROBOSTACK_LOOKED_UP_${accessor}`]) {
        value = tuple[`__ROBOSTACK_LOOKED_UP_${accessor}`];
    }

    return value;
}